import axios from 'axios'
// import store from '@/store'
// import Cookies from 'js-cookie'
// import { router } from '../router/index'
import MIS from '../utils/mis';
import { Message } from 'element-ui';

// 设置cross跨域 并设置访问权限 允许跨域携带cookie信息
// axios.defaults.withCredentials = true

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // api的base_url
  timeout: 300000 // 请求超时时间
})

MIS.interceptors(service, Message);

// service.interceptors.request.use(
//   config => {
//     if (Cookies.get('token')) {
//       // config.headers['token'] = '132C5E6E9B7D433B97EDEA15C4BE5BC6'//Cookies.get('token');
//       config.headers['token'] = Cookies.get('token');
//       config.headers['channelCode'] = 'uc_admin3';
//     }
//     return config;
//   },
//   err => {
//     return Promise.reject(err);
//   });


// // respone拦截器
// service.interceptors.response.use(
//   response => response,
//   error => {
//     if (error.response) {
//       switch (error.response.status) {
//         case 401:
//           router.replace({
//             path: '/login'
//           })
//           break;
//         case 500: //全局错误提示拦截
//           window.mainVue.$message.error(error.response.data&&error.response.data.message || "网络异常！");
//           store.commit("setPageLoading", false);
//       }
//     } else {
//       window.mainVue.$message.error("网络异常！");
//     }
//     return Promise.reject(error.response&&error.response.data&&error.response.data.message)
//   })

export default service
